module.exports = __webpack_public_path__ + "images/slobodnadomena-logo-green-be514ca445a3a0c6afdfadef88829d8f.svg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/slobodnadomena-logo-green.svg
// module id = 4
// module chunks = 0